import React, { useRef, useState, useCallback, memo } from 'react'
import { isMobile } from 'react-device-detect'
import { useLocation } from 'react-router-dom'
import '../../css/Product.css'
import ProductSortLayer from './ProductSortLayer'

const imgURL = '/images'

interface headerType {
  totalCount: number
  type: string
  setType: React.Dispatch<React.SetStateAction<string>>
  isSort?: boolean
  setIsSort: React.Dispatch<React.SetStateAction<boolean>>
  sortKeyword: string
  setSortKeyword: React.Dispatch<React.SetStateAction<string>>
  setSortKeywordLabel: React.Dispatch<React.SetStateAction<string>>
  sortDirection: string
  setSortDirection: React.Dispatch<React.SetStateAction<string>>
  sortKeywordLabel?: string
  setIsFilter?: React.Dispatch<React.SetStateAction<boolean>>
  filterTotal?: number
}

const ProductHeader = ({
  totalCount,
  type,
  setType,
  isSort,
  setIsSort,
  sortKeyword,
  setSortKeyword,
  sortKeywordLabel,
  setSortKeywordLabel,
  sortDirection,
  setSortDirection,
  setIsFilter,
  filterTotal,
}: headerType) => {
  const [isSortIcon, setIsSortIcon] = useState<boolean>(false)
  const btnSortRef = useRef<any>(null)
  const location = useLocation()

  const sortHandler = useCallback(() => {
    setIsSort((prev) => !prev)
    setIsSortIcon((prev) => !prev)
  }, [setIsSort])

  const productTypeHandler = useCallback(() => {
    setType((prevType) => (prevType === 'thumb' ? 'list' : 'thumb'))
  }, [setType])

  return (
    <div className='product_list_header'>
      <div className='product_list_num'>
        <span>{totalCount || 0}</span>개의 상품
      </div>
      <ul className='product_list_option'>
        <li>
          <button ref={btnSortRef} className='btn_sort' onClick={sortHandler}>
            {sortKeywordLabel || '정렬'}
            {!isMobile && <img src={`${imgURL}/icon_arrow_${isSortIcon ? 'up' : 'down'}.png`} alt='' />}
          </button>
          {!isMobile && isSort && (
            <ProductSortLayer
              setIsModal={setIsSort}
              setSortKeyword={setSortKeyword}
              sortKeyword={sortKeyword}
              setSortKeywordLabel={setSortKeywordLabel}
              setSortDirection={setSortDirection}
              sortDirection={sortDirection}
              setIsSortIcon={setIsSortIcon}
              btnSortRef={btnSortRef}
            />
          )}
        </li>
        {!location.pathname.includes('festivalmanyproducts') && (
          <li>
            <button className='btn_filter' onClick={() => setIsFilter && setIsFilter(true)}>
              필터
              {Number(filterTotal) !== 0 && <span>{filterTotal}</span>}
            </button>
          </li>
        )}
        <li>
          <button className='btn_listtype' onClick={productTypeHandler}>
            <img src={`${imgURL}/icon_list${type === 'thumb' ? '' : '_thumb'}.png`} alt='상품보기 썸네일형' />
          </button>
        </li>
      </ul>
    </div>
  )
}

export default memo(ProductHeader)
